import React from 'react';
import { GridColumnGroupHeaderParams } from '@mui/x-data-grid-premium';
import { Typography } from 'src/components/PulseUI';

interface GroupHeaderProps extends GridColumnGroupHeaderParams {
  icon?: React.ReactNode;
  isVolume?: boolean;
}

const GroupHeader = (props: GroupHeaderProps) => {
  const { icon: _icon, isVolume = false, ...params } = props;

  return (
    <div
      className={`flex h-14 items-center self-stretch border-none w-screen ${
        isVolume ? 'mx-1 border-b border-[#005B38]' : ''
      }`}
    >
      <Typography variant="subtitle2" bold>
        {params.headerName}
      </Typography>
    </div>
  );
};

export default GroupHeader;
